import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './en.json'
import ja from './ja.json'

const lng = navigator.language === 'ja' ? 'ja' : 'en'

i18n.use(initReactI18next).init({
  resources: {
    ja: { translation: ja },
    en: { translation: en },
  },
  lng,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
